import * as Yup from 'yup';

export const updateAssignedAgentFormValidationSchema = (isRequired: boolean) => (isRequired
  ? Yup.string().email().required('Il campo è obbligatorio')
  : Yup.string().email().nullable());
